/* eslint-disable no-unused-vars */
import React from 'react';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import TimePicker from '@mui/lab/TimePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateAdapter from '@mui/lab/AdapterMoment';
import TextField from '@material-ui/core/TextField';
import dateIcon from './Date.svg';
import timeIcon from './Time.svg';

const timeStyle = {
  background: 'white',
  border: '1px solid #CAD8FF',
  borderRadius: '12px',
  color: 'black',
  fontFamily: 'Poppins',
  fontSize: '12px',
  margin: '0px',
  padding: '5.225px 11px',
  width: '105px'
};

const dateStyle = {
  background: 'white',
  border: '1px solid #CAD8FF',
  borderRadius: '12px',
  color: 'black',
  fontFamily: 'Poppins',
  fontSize: '12px',
  margin: '0px',
  marginRight: '20px',
  padding: '5.225px 11px',
  width: '200px'
};

/**
 * @typedef {Object} CustomDatePickerProps
 * @property {(date: Date) => void} [onChange] Callback fired when the date value changes
 * @property {Date|string} [value] Selected date value
 * @property {boolean} [timePicker] Whether to additionally render the time picker
 */

/**
 * @param {CustomDatePickerProps} props
 */

const CustomDatePicker = ({ value, timePicker = true, onChange = (date) => {} }) => {
  const handleChange = (value) => {
    onChange(value?._d);
  };

  return (
    <LocalizationProvider dateAdapter={DateAdapter}>
      <DesktopDatePicker
        clearable
        clearText="clear me"
        components={{
          OpenPickerIcon: () => <img alt="date picker" src={dateIcon} />
        }}
        inputFormat="DD/MM/yyyy"
        InputProps={{
          disableUnderline: true,
          style: dateStyle
        }}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} />}
        value={value || ''}
      />

      {timePicker && (
        <TimePicker
          clearable
          components={{
            OpenPickerIcon: () => <img alt="date picker" src={timeIcon} />
          }}
          InputProps={{
            disableUnderline: true,
            style: timeStyle
          }}
          onChange={handleChange}
          renderInput={(params) => <TextField {...params} />}
          value={value || ''}
        />
      )}
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
